import React from 'react';
import { SvgIcon } from '../components/svgIcon';
import { SvgIconProps } from '../components/svgIcon/model';

export const ArrowDownIcon = React.forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <SvgIcon cacheName="arrowDown" ref={ref as any} {...props}>
      <path d="M17.5193 13.9663C17.84 13.6455 17.84 13.1254 17.5193 12.8048C17.1985 12.484 16.6785 12.484 16.3578 12.8048L13.2016 15.9611L13.2007 6.82135C13.2007 6.36764 12.8329 6 12.3792 6C11.9256 6 11.558 6.36775 11.558 6.82135L11.5589 15.9614L8.4021 12.8044C8.08134 12.4837 7.56126 12.4837 7.2406 12.8044C7.08016 12.9648 7 13.175 7 13.3852C7 13.5954 7.08016 13.8056 7.24049 13.9659L11.7992 18.5249C11.9533 18.679 12.1622 18.7655 12.3801 18.7655C12.5979 18.7655 12.8069 18.679 12.961 18.5249L17.5193 13.9663Z" />
    </SvgIcon>
  );
});
